import { Component, Vue } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class Footer extends Vue {
   public title: string = 'Footer';

   public configs = new CommonConfig();

   public created() {
      console.log(this.$t('header.home'));
   }
   public toRadar() {
      window.open(this.configs.radarHost, '_blank');
   }

   public navToRIFOEpic() {
      window.open(`https://${this.configs.worldWide[0]}`, '_blank');
   }
}
